// src/app/core/services/signout-state.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SignoutStateService {
  isSigningOut = false;
}
